import './ProfileCard.scss';

import { useProfile } from "../hooks/useProfile";

import ProfileAvatar from "./components/ProfileAvatar/ProfileAvatar";
import ProfileName from "./components/ProfileName/ProfileName";
import ProfileDescription from "./components/ProfileDescription/ProfileDescription";

const ProfileCard = () => {
    const { user } = useProfile();

    return (
        <div className={"profile-card"}>
            <div className={"profile-card_container"}>
                <div className={"profile-card_main"}>
                    <ProfileAvatar firstName={user.attributes.first_name} lastName={user.attributes.last_name}/>
                    <ProfileName firstName={user.attributes.first_name} lastName={user.attributes.last_name} email={user.attributes.email}/>
                </div>
                <div className={"profile-card_additional"}>
                    <ProfileDescription branch={user.attributes.branch_id} company={user.attributes.rescue_company_id}/>
                </div>
            </div>
        </div>
    )
}

export default ProfileCard;